module.exports = __webpack_public_path__ + "img/union_2.a12c7660.jpg";